define(["exports", "@babel/runtime/helpers/esm/extends", "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose", "react", "styled-components", "../../themes", "polished", "@reach/combobox", "../Typography", "../../", "../Alert", "dlv"], function (_exports, _extends2, _objectWithoutPropertiesLoose2, _react, _styledComponents, _themes, _polished, _combobox, _Typography, _, _Alert, _dlv) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _react = _interopRequireWildcard(_react);
  _styledComponents = _interopRequireWildcard(_styledComponents);
  _Alert = _interopRequireDefault(_Alert);
  _dlv = _interopRequireDefault(_dlv);
  var _excluded = ["placeholder", "isExpandable", "searchTerm", "onSearchTermChange", "searchResults", "onSelect", "shouldDisplayAvatar", "onItemClick"];
  var ComboboxInputStyled = (0, _styledComponents.default)(_combobox.ComboboxInput).withConfig({
    displayName: "SearchInput__ComboboxInputStyled",
    componentId: "sc-hi52t4-0"
  })(["border-radius:2px;border:none;color:", ";font-size:1.4em;font-weight:", ";line-height:22px;outline:none;padding:4px 16px 4px 40px;pointer-events:auto;width:100%;", " &::placeholder{color:", ";font-weight:", ";}&:focus,&:hover{", "}", " ", ""], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.dark;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.font.regular;
  }, function (_ref3) {
    var isExpandable = _ref3.isExpandable;
    return isExpandable && (0, _styledComponents.css)(["opacity:", ";transition:", ";transition:width 1000ms cubic-bezier(0.77,0,0.175,1),opacity 1000ms cubic-bezier(0.77,0,0.175,1);width:", ";"], function (_ref4) {
      var shouldExpand = _ref4.shouldExpand;
      return shouldExpand ? '1' : '0';
    }, function (_ref5) {
      var theme = _ref5.theme;
      return "border 0.4s " + theme.easing.ease + ", box-shadow 0.2s " + theme.easing.ease;
    }, function (_ref6) {
      var shouldExpand = _ref6.shouldExpand;
      return shouldExpand ? '100%' : '0%';
    });
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.colors.darkGray;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.font.regular;
  }, _themes.focusBoxShadow, function (_ref9) {
    var disabled = _ref9.disabled;
    return disabled && (0, _styledComponents.css)(["background-color:", ";cursor:not-allowed;"], function (_ref10) {
      var theme = _ref10.theme;
      return theme.colors.lightGray;
    });
  }, function (_ref11) {
    var error = _ref11.error;
    return error && (0, _styledComponents.css)(["border-color:", ";&:focus,&:hover{border:solid 1px ", ";box-shadow:0 0 3px 0 ", ";outline:none;}"], function (_ref12) {
      var theme = _ref12.theme;
      return theme.colors.red;
    }, function (_ref13) {
      var theme = _ref13.theme;
      return theme.colors.red;
    }, function (_ref14) {
      var theme = _ref14.theme;
      return theme.colors.red;
    });
  });

  var Container = _styledComponents.default.label.withConfig({
    displayName: "SearchInput__Container",
    componentId: "sc-hi52t4-1"
  })(["display:flex;pointer-events:none;width:100%;", ";"], function (_ref15) {
    var isExpandable = _ref15.isExpandable;
    return isExpandable && (0, _styledComponents.css)(["justify-content:flex-end;"]);
  });

  var IconContainer = _styledComponents.default.div.withConfig({
    displayName: "SearchInput__IconContainer",
    componentId: "sc-hi52t4-2"
  })(["align-items:center;display:flex;justify-content:center;margin-right:-30px;pointer-events:auto;z-index:1;> box-icon{fill:", ";}", ""], function (_ref16) {
    var theme = _ref16.theme;
    return theme.colors.dark;
  }, function (_ref17) {
    var isExpandable = _ref17.isExpandable;
    return isExpandable && (0, _styledComponents.css)(["> box-icon{fill:", ";transition:transform 1000ms cubic-bezier(0.77,0,0.175,1),fill 1000ms cubic-bezier(0.77,0,0.175,1);}", ";"], function (_ref18) {
      var theme = _ref18.theme;
      return theme.colors.white;
    }, function (_ref19) {
      var shouldExpand = _ref19.shouldExpand;
      return shouldExpand ? (0, _styledComponents.css)(["> box-icon{fill:", ";transform:rotate(-90deg);}"], function (_ref20) {
        var theme = _ref20.theme;
        return theme.colors.dark;
      }) : (0, _styledComponents.css)(["cursor:pointer;"]);
    });
  });

  var ComboboxPopoverStyled = (0, _styledComponents.default)(_combobox.ComboboxPopover).withConfig({
    displayName: "SearchInput__ComboboxPopoverStyled",
    componentId: "sc-hi52t4-3"
  })(["background:", ";border-radius:2px;box-shadow:0 1px 2px 0 ", ";margin-top:2px;padding-bottom:16px;padding-top:16px;z-index:1000;"], function (_ref21) {
    var theme = _ref21.theme;
    return theme.colors.white;
  }, function (_ref22) {
    var theme = _ref22.theme;
    return (0, _polished.rgba)(theme.colors.dark, 0.3);
  });
  var ComboboxListStyled = (0, _styledComponents.default)(_combobox.ComboboxList).withConfig({
    displayName: "SearchInput__ComboboxListStyled",
    componentId: "sc-hi52t4-4"
  })(["", ";"], _themes.resetList);
  var ComboboxOptionStyled = (0, _styledComponents.default)(_combobox.ComboboxOption).withConfig({
    displayName: "SearchInput__ComboboxOptionStyled",
    componentId: "sc-hi52t4-5"
  })(["align-items:center;background:", ";display:flex;font-size:1.6em;height:48px;padding-left:16px;padding-right:16px;> span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}&[aria-selected='true'],&:hover,&:focus,&[aria-selected='true']:hover{background:", ";outline:none;}[data-user-value]{font-weight:", ";}"], function (_ref23) {
    var active = _ref23.active,
        theme = _ref23.theme;
    return active === 'true' ? theme.colors.lightGray : theme.colors.white;
  }, function (_ref24) {
    var theme = _ref24.theme;
    return theme.colors.lightGray;
  }, function (_ref25) {
    var theme = _ref25.theme;
    return theme.font.bold;
  });
  var ComboboxOptionTextStyled = (0, _styledComponents.default)(_combobox.ComboboxOptionText).withConfig({
    displayName: "SearchInput__ComboboxOptionTextStyled",
    componentId: "sc-hi52t4-6"
  })([""]);
  var ListTitle = (0, _styledComponents.default)(_Typography.H3).withConfig({
    displayName: "SearchInput__ListTitle",
    componentId: "sc-hi52t4-7"
  })(["line-height:0;margin-left:16px;"]);

  var SearchInput = function SearchInput(_ref26) {
    var placeholder = _ref26.placeholder,
        isExpandable = _ref26.isExpandable,
        searchTerm = _ref26.searchTerm,
        onSearchTermChange = _ref26.onSearchTermChange,
        searchResults = _ref26.searchResults,
        onSelect = _ref26.onSelect,
        shouldDisplayAvatar = _ref26.shouldDisplayAvatar,
        onItemClick = _ref26.onItemClick,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_ref26, _excluded);
    var wrapperRef = (0, _react.useRef)(null);

    var _useState = (0, _react.useState)(false),
        isFocused = _useState[0],
        setIsFocused = _useState[1];

    return /*#__PURE__*/_react.default.createElement(_combobox.Combobox, {
      onSelect: onSelect,
      ref: wrapperRef
    }, /*#__PURE__*/_react.default.createElement(Container, {
      isExpandable: isExpandable
    }, /*#__PURE__*/_react.default.createElement(IconContainer, {
      isExpandable: isExpandable,
      shouldExpand: searchTerm || isFocused
    }, /*#__PURE__*/_react.default.createElement("box-icon", {
      name: "search",
      rotate: isExpandable ? '90' : '0'
    })), /*#__PURE__*/_react.default.createElement(ComboboxInputStyled, (0, _extends2.default)({
      onChange: onSearchTermChange,
      "aria-label": "Cities",
      type: "search",
      placeholder: placeholder,
      isExpandable: isExpandable,
      shouldExpand: searchTerm || isFocused,
      autocomplete: "off",
      onFocus: function onFocus() {
        return setIsFocused(true);
      },
      onBlur: function onBlur() {
        return setIsFocused(false);
      }
    }, rest))), searchResults.length > 0 && /*#__PURE__*/_react.default.createElement(ComboboxPopoverStyled, null, /*#__PURE__*/_react.default.createElement(ComboboxListStyled, null, searchResults.map(function (result) {
      return result.list && result.list.length > 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ListTitle, null, result.title), /*#__PURE__*/_react.default.createElement(_.Spacing, null), result.list.map(function (item) {
        return /*#__PURE__*/_react.default.createElement(ComboboxOptionStyled, {
          key: (0, _dlv.default)(item, result.itemIdKeyPath),
          value: (0, _dlv.default)(item, result.itemValueKeyPath),
          onClick: function onClick() {
            return onItemClick(item);
          }
        }, shouldDisplayAvatar && ((0, _dlv.default)(item, result.itemAvatarTextKeyPath) || (0, _dlv.default)(item, result.itemAvatarImgKeyPath)) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.Avatar, {
          kind: (0, _dlv.default)(item, result.itemAvatarImgKeyPath) ? 'image' : 'text',
          size: "sm",
          name: (0, _dlv.default)(item, result.itemAvatarTextKeyPath),
          src: (0, _dlv.default)(item, result.itemAvatarImgKeyPath)
        }), /*#__PURE__*/_react.default.createElement(_.Spacing, {
          horizontal: true,
          size: "small"
        })), /*#__PURE__*/_react.default.createElement(ComboboxOptionTextStyled, null));
      })) : result.error ? /*#__PURE__*/_react.default.createElement(_Alert.default, {
        kind: "danger"
      }, /*#__PURE__*/_react.default.createElement("box-icon", {
        name: "error-circle",
        type: "solid"
      }), result.errorMessage) : null;
    }))));
  };

  SearchInput.defaultProps = {
    isExpandable: false,
    isLoading: false,
    placeholder: '',
    shouldDisplayAvatar: false
  };
  var _default = SearchInput;
  _exports.default = _default;
});